import loading from "../../assets/Icons/loading.svg";

const IconLoadingModal = () =>{
   return(
      <div className="flex justify-center items-center text-white rounded-lg">
         <img src={loading} className="iconLoadingModal" />
      </div>
   )
}

export default IconLoadingModal;
